import { ExternalUserEQueriesFilter } from '../../../e-queries/models/external-user-e-queries-filter';

export class SponsorEQueryFilterItem extends ExternalUserEQueriesFilter { }

